import React from 'react';

function ButtonAccountComponent() {
  return (
    <button type="submit" className="btn-account line-Animation">
      Criar Conta
    </button>
  );
}

export default ButtonAccountComponent;
